/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'

interface DividerProps {
  className?: string
}

/**
 * Horizontal divider line for scheduler wizard sections
 */
const Divider: React.FC<DividerProps> = ({ className }) => {
  return (
    <div
      className={className}
      css={css`
        width: 100%;
        height: 1px;
        background-color: #3a4659;
      `}
    />
  )
}

export default Divider
